import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=6c2b2f51&scoped=true"
import script from "./panel.vue?vue&type=script&lang=js"
export * from "./panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b2f51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2b2f51')) {
      api.createRecord('6c2b2f51', component.options)
    } else {
      api.reload('6c2b2f51', component.options)
    }
    module.hot.accept("./panel.vue?vue&type=template&id=6c2b2f51&scoped=true", function () {
      api.rerender('6c2b2f51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/quick-send-list/panel.vue"
export default component.exports